import React from "react";

const CtaSection = () => {
  return (
    <section
      id="cta"
      className="relative flex min-h-[460px] w-full items-center overflow-hidden bg-[#010710] sm:min-h-[500px] lg:min-h-[540px]"
    >
      {/* High-Resolution Earth Horizon Background with Sunrise Flare */}
      <img
        src="/images/earth-cta-bg.png"
        alt="Global AI Opportunity Network"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-right sm:object-center"
      />

      {/* Subtle Dark Vignette on Left for Peak Text Legibility */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#010710]/80 via-[#010710]/40 to-transparent sm:via-[#010710]/20" />

      {/* Main Content (Aligned Left matching exact design) */}
      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-6 py-16 sm:py-20 lg:px-[70px] lg:py-24">
        <div className="flex max-w-[850px] lg:max-w-[1000px] flex-col gap-5 sm:gap-7">
          {/* Eyebrow Tag */}
          <p className="text-[11px] font-bold uppercase tracking-[2.5px] text-white/80 sm:text-[12px]">
            YOUR AI OPPORTUNITY AWAITS
          </p>

          {/* Main Headline */}
          <h2 className="text-[22px] min-[420px]:text-[25px] sm:text-[32px] md:text-[38px] lg:text-[44px] xl:text-[48px] font-bold leading-[1.18] tracking-tight text-white">
            <span className="block whitespace-nowrap">Enough about what AI could do.</span>
            <span className="block whitespace-nowrap">Let’s see what it could do for your</span>
            <span className="block">business.</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;